<template>
  <div v-if="relatives">
    <div v-if="data">
      <Top />
      <div class="container">
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-md-6">
            <div class="margin-top-50"></div>
            <div class="header-wrapper">
              <h1 class="text-primary-fh left-header" v-html="data.familytree.inviteheader"></h1>
            </div>
            <p v-html="data.familytree.inviteInfoText"></p>
            <div class="clearfix"></div>
          </div>
          <div class="col-sm"></div>
        </div>
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-md-6">
            <div class="card">
              <div class="card-body text-left">
                <h6 class="card-title">Personligt meddelande (rekommenderat)</h6>
                <input
                  class="form-control form-control-lg personal-message"
                  type="text"
                  placeholder="Egen text till din släkting.."
                  v-model="personalMessage"
                />
                <div class="clearfix"></div>
                <h6 class="text-dark">Förhandsvisning</h6>
                <div class="card override-card">
                  <div class="card-body override-card-body text-left">
                    <p v-html="data.familytree.topPreviewText.replace('{fullName}', fullname + ':')"></p>
                    <hr />
                    <p v-text="personalMessage"></p>
                    <p v-if="personalMessage.length < 1"><i class="text-muted">Ditt personliga meddelande..</i></p>
                    <hr />
                    <p v-html="data.familytree.bottomPreviewText.replace('{invitationLink}', '[Länk kommer här]')"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="card" v-if="isGenNegativeIndexPatient">
              <div class="card-body text-left">
                <span class="text-danger" v-html="data.familytree.disclaimerFirstDegree"></span>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="card">
              <div class="card-body text-left">
                <h6 class="card-title">Mottagare (en eller flera)</h6>
                <small class="small-right">Klicka på respektive namn för att markera</small>
                <hr v-if="aliveRelatives.length > 0" />
                <div v-if="aliveRelatives.length === 0">
                  Inga släktingar tillgängliga.
                </div>
                <div v-for="(relative, i) in aliveRelatives" v-bind:key="i">
                  <label class="custom-checkbox">
                  <input
                    class="custom-checkbox-input"
                    name="selectedRelative"
                    :value="relative"
                    @change="addOrRemoveSelectedRelative(relative, i, $event)"
                    :disabled="isRelativeInvited(relative)"
                    type="checkbox"
                  />
                  <span class="custom-checkbox-text" v-text="relative.firstName + ' ' + relative.lastName"></span>
                  </label>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm"></div>
        </div>
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-md-6">
            <div class="clearfix"></div>
            <button
              class="btn btn-primary btn-lg btn-block"
              :disabled="selectedRelatives.length === 0 || aliveRelatives === 0"
              @click="prepareInvites()">
            Nästa
            </button>
            <div class="clearfix"></div>
            <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button>
            <div class="clearfix"></div>
            <small>Välj minst en mottagare för att gå vidare.</small>
            <div class="clearfix"></div>
          </div>
          <div class="col-sm"></div>
        </div>
      </div>
      <div class="clearfix"></div>
      <Bottom />
    </div>
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'
import { parseJwt } from '../plugins/jwtparser'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'familytreeinvite',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      isGenNegativeIndexPatient: false,
      fullname: '',
      personalMessage: '',
      relatives: [],
      selectedRelatives: []
    }
  },
  methods: {
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    addOrRemoveSelectedRelative (r, i, event) {
      if (event.target.checked) {
        this.selectedRelatives.push(r)
      } else {
        this.selectedRelatives = this.selectedRelatives.filter(relative => relative !== r)
      }
    },
    isRelativeInvited (relative) {
      if (relative.invitationStatus === 'Inbjuden' ||
        relative.invitationStatus === 'Accepterat') {
        return true
      } else {
        return false
      }
    },
    isFirstDegreeRelative (relative) {
      // 1 = mother, 2 = father, 7 = child, 9 = sibling
      const firstDegreeRelatives = [1, 2, 7, 9]
      if (firstDegreeRelatives.includes(relative.familyRelation)) {
        return true
      } else {
        return false
      }
    },
    isGenNegativeIdxPatient (djwt) {
      for (const [key, value] of Object.entries(djwt)) {
        if (key.includes('isGeneNegative') && value === 'true') {
          this.isGenNegativeIndexPatient = true
        }
      }
    },
    prepareInvites () {
      localStorage.setItem('selectedRelatives', JSON.stringify(this.selectedRelatives))
      sessionStorage.setItem('personalMessage', this.personalMessage)
      sessionStorage.setItem('geneNegative', this.isGenNegativeIndexPatient)
      this.$router.push('/sendinvite')
    }
  },
  computed: {
    aliveRelatives () {
      return this.relatives.filter(r => r.alive === true)
    }
  },
  beforeMount () {
    this.fullname = sessionStorage.getItem('fullname')
  },
  async mounted () {
    axios._get(config.relativeUri).then(response => {
      this.relatives = response.data.relatives
      // Below is mock to try an invited relative in the list
      // It should be disabled, low opacity and '✓'
      /*
            this.relatives[0].invitationStatus = 'Inbjuden'
      */
    }).catch((error) => {
      if (error.response && error.response.status === 401) {
        window.location.href = window.location.origin.concat('/error')
      } else {
        console.log('Could not get relatives: ' + error)
      }
    })
    this.data = await request({
      query: `
        {
          familytree {
            inviteheader
            inviteInfoText
            topPreviewText
            bottomPreviewText
            disclaimerFirstDegree
          }
        }
      `
    })
    if (sessionStorage.getItem('jwt') !== null) {
      this.isGenNegativeIdxPatient(parseJwt(sessionStorage.getItem('jwt')))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 75px;
}
.margin-top-50 {
  margin-top: 50px;
}
.header-wrapper {
  display: flex;
}
.text-left {
  text-align: left;
}
.card {
  border: 2px solid #bae2ef;
  border-radius: 15px;
  margin-top: 2rem;
}
.card-body {
  background: #e5f1f5;
  border-radius: 15px;
}
.override-card {
  margin-top: 1vh;
  border-radius: 0;
  border: 2px solid #c7c7c7;
}
.override-card-body {
  border-radius: 0;
  background: #ebebeb;
  color: #4e4e4e;
}
.custom-checkbox-input {
  display: none;
}
.custom-checkbox-text {
  cursor: pointer;
  user-select: none;
}
.custom-checkbox-input:checked ~ .custom-checkbox-text {
  color: green;
  text-decoration: underline;
  font-weight: bold;
}
.custom-checkbox-input:disabled ~ .custom-checkbox-text {
  opacity: 0.3
}
.custom-checkbox-input:disabled ~ .custom-checkbox-text::after {
  content: " ✓";
}
.small-right {
  position: absolute;
  top: 0;
  right: 0;
  margin: 1em;
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/FamilyTreeInvite.vue